// extracted by mini-css-extract-plugin
module.exports = {"classroom":"styles_classroom__1Y8sp","classroom-name":"styles_classroom-name__Y7syV"};